import { render, staticRenderFns } from "./Picture_edit.vue?vue&type=template&id=b21dfe94&style=true"
import script from "./Picture_edit.vue?vue&type=script&lang=js"
export * from "./Picture_edit.vue?vue&type=script&lang=js"
import style0 from "./Picture_edit.vue?vue&type=style&index=0&id=b21dfe94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports